// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/user_data.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
/**
 * Describes the file vitesse/v1/user_data.proto.
 */
export const file_vitesse_v1_user_data = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_entitlements, file_vitesse_v1_common]);
/**
 * Describes the message vitesse.v1.LabelEdit.
 * Use `create(LabelEditSchema)` to create a new message.
 */
export const LabelEditSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 0);
/**
 * Describes the message vitesse.v1.PutLabelsRequest.
 * Use `create(PutLabelsRequestSchema)` to create a new message.
 */
export const PutLabelsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 1);
/**
 * Describes the message vitesse.v1.PutLabelsReply.
 * Use `create(PutLabelsReplySchema)` to create a new message.
 */
export const PutLabelsReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 2);
/**
 * Describes the message vitesse.v1.LabelsSubscribeRequest.
 * Use `create(LabelsSubscribeRequestSchema)` to create a new message.
 */
export const LabelsSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 3);
/**
 * Describes the message vitesse.v1.LabelEvent.
 * Use `create(LabelEventSchema)` to create a new message.
 */
export const LabelEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 4);
/**
 * @generated from enum vitesse.v1.LabelEvent.Op
 */
export var LabelEvent_Op;
(function (LabelEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    LabelEvent_Op[LabelEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * label set/changed; text in `label`
     *
     * @generated from enum value: OP_PUT = 1;
     */
    LabelEvent_Op[LabelEvent_Op["PUT"] = 1] = "PUT";
    /**
     * label removed; `label` empty
     *
     * @generated from enum value: OP_DELETE = 2;
     */
    LabelEvent_Op[LabelEvent_Op["DELETE"] = 2] = "DELETE";
})(LabelEvent_Op || (LabelEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.LabelEvent.Op.
 */
export const LabelEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_user_data, 4, 0);
/**
 * Describes the message vitesse.v1.UserControllerDescription.
 * Use `create(UserControllerDescriptionSchema)` to create a new message.
 */
export const UserControllerDescriptionSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 5);
/**
 * Describes the message vitesse.v1.PutControllerDescriptionRequest.
 * Use `create(PutControllerDescriptionRequestSchema)` to create a new message.
 */
export const PutControllerDescriptionRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 6);
/**
 * Describes the message vitesse.v1.PutControllerDescriptionReply.
 * Use `create(PutControllerDescriptionReplySchema)` to create a new message.
 */
export const PutControllerDescriptionReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 7);
/**
 * Describes the message vitesse.v1.ControllerDescriptionsSubscribeRequest.
 * Use `create(ControllerDescriptionsSubscribeRequestSchema)` to create a new message.
 */
export const ControllerDescriptionsSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 8);
/**
 * Describes the message vitesse.v1.ControllerDescriptionEvent.
 * Use `create(ControllerDescriptionEventSchema)` to create a new message.
 */
export const ControllerDescriptionEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 9);
/**
 * @generated from enum vitesse.v1.ControllerDescriptionEvent.Op
 */
export var ControllerDescriptionEvent_Op;
(function (ControllerDescriptionEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    ControllerDescriptionEvent_Op[ControllerDescriptionEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * description set/changed; text in `description`
     *
     * @generated from enum value: OP_PUT = 1;
     */
    ControllerDescriptionEvent_Op[ControllerDescriptionEvent_Op["PUT"] = 1] = "PUT";
    /**
     * description removed; `description` empty
     *
     * @generated from enum value: OP_DELETE = 2;
     */
    ControllerDescriptionEvent_Op[ControllerDescriptionEvent_Op["DELETE"] = 2] = "DELETE";
})(ControllerDescriptionEvent_Op || (ControllerDescriptionEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.ControllerDescriptionEvent.Op.
 */
export const ControllerDescriptionEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_user_data, 9, 0);
/**
 * Describes the message vitesse.v1.PutGatewayDescriptionRequest.
 * Use `create(PutGatewayDescriptionRequestSchema)` to create a new message.
 */
export const PutGatewayDescriptionRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 10);
/**
 * Describes the message vitesse.v1.PutGatewayDescriptionReply.
 * Use `create(PutGatewayDescriptionReplySchema)` to create a new message.
 */
export const PutGatewayDescriptionReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 11);
/**
 * Describes the message vitesse.v1.GatewayDescriptionSubscribeRequest.
 * Use `create(GatewayDescriptionSubscribeRequestSchema)` to create a new message.
 */
export const GatewayDescriptionSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 12);
/**
 * Describes the message vitesse.v1.GatewayDescriptionEvent.
 * Use `create(GatewayDescriptionEventSchema)` to create a new message.
 */
export const GatewayDescriptionEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 13);
/**
 * @generated from enum vitesse.v1.GatewayDescriptionEvent.Op
 */
export var GatewayDescriptionEvent_Op;
(function (GatewayDescriptionEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    GatewayDescriptionEvent_Op[GatewayDescriptionEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: OP_PUT = 1;
     */
    GatewayDescriptionEvent_Op[GatewayDescriptionEvent_Op["PUT"] = 1] = "PUT";
    /**
     * @generated from enum value: OP_DELETE = 2;
     */
    GatewayDescriptionEvent_Op[GatewayDescriptionEvent_Op["DELETE"] = 2] = "DELETE";
})(GatewayDescriptionEvent_Op || (GatewayDescriptionEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.GatewayDescriptionEvent.Op.
 */
export const GatewayDescriptionEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_user_data, 13, 0);
/**
 * Describes the message vitesse.v1.UserSymbolCombo.
 * Use `create(UserSymbolComboSchema)` to create a new message.
 */
export const UserSymbolComboSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 14);
/**
 * Describes the message vitesse.v1.ListSymbolCombosRequest.
 * Use `create(ListSymbolCombosRequestSchema)` to create a new message.
 */
export const ListSymbolCombosRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 15);
/**
 * Describes the message vitesse.v1.ListSymbolCombosReply.
 * Use `create(ListSymbolCombosReplySchema)` to create a new message.
 */
export const ListSymbolCombosReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 16);
/**
 * Describes the message vitesse.v1.PutSymbolComboRequest.
 * Use `create(PutSymbolComboRequestSchema)` to create a new message.
 */
export const PutSymbolComboRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 17);
/**
 * Describes the message vitesse.v1.PutSymbolComboReply.
 * Use `create(PutSymbolComboReplySchema)` to create a new message.
 */
export const PutSymbolComboReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 18);
/**
 * Describes the message vitesse.v1.DeleteSymbolComboRequest.
 * Use `create(DeleteSymbolComboRequestSchema)` to create a new message.
 */
export const DeleteSymbolComboRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 19);
/**
 * Describes the message vitesse.v1.DeleteSymbolComboReply.
 * Use `create(DeleteSymbolComboReplySchema)` to create a new message.
 */
export const DeleteSymbolComboReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_user_data, 20);
/**
 * Browser/AI-facing service, bridged by api-gateway. PutLabel/PutLabels and
 * PutControllerDescription are unary → KV Put/Delete. The Subscribe* RPCs are
 * server-streaming → a shared KV watch fanned out per-replica (one upstream
 * watch, N subscribers).
 *
 * @generated from service vitesse.v1.UserData
 */
export const UserData = /*@__PURE__*/ serviceDesc(file_vitesse_v1_user_data, 0);
//# sourceMappingURL=user_data_pb.js.map